document.body.addEventListener('click', function (e) {
    let target = e.target.closest('.quick-add-bulk-popup-wrapper');
    if (target) {
        e.preventDefault();
        var url = target.getAttribute('data-product-link');
        console.log(url);

        if (!url) {
            console.error('No URL found for the product');
            return;
        }

        document.querySelector('.featured-collection-loader-wrapper').style.display = 'flex';
        document.body.classList.add('quick-view-active');

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(data => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(data, 'text/html');
                var productHtml = doc.querySelector('.product-main-wrapper');

                if (productHtml) {
                    document.querySelector('.featured-collection-data-popup-wrapper').style.display = 'block';
                    document.querySelector('.featured-collection-data-popup').innerHTML = productHtml.innerHTML;
                    document.querySelector('.featured-collection-loader-wrapper').style.display = 'none';
                } else {
                    console.error('Product main wrapper not found on the page');
                }
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }
});
